import { StylesConfig } from 'react-select';
import theme from '../../styles/userflow';

export const selectStyles: StylesConfig = {
  menu: base => ({
    ...base,
    width: 273,
    overflow: 'hidden',
    margin: '-10px 0 0 0',
  }),
  menuList: base => ({
    ...base,
    maxHeight: 250,
  }),
  singleValue: base => ({
    ...base,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    color: theme.colors.blue,
    padding: 0,
    margin: 0,
  }),
  control: base => ({
    ...base,
    background: 'none',
    border: 0,
    boxShadow: 'none',
    margin: 0,
    padding: 0,
    cursor: 'pointer',
  }),
  valueContainer: base => ({
    ...base,
    padding: 0,
  }),
};
